export const mustache = (string, mustache, newVal) => {
  return string.replace(`{{${mustache}}}`, newVal);
}
